import { render, staticRenderFns } from "./ginpass.vue?vue&type=template&id=7f5e251c&scoped=true&"
import script from "./ginpass.vue?vue&type=script&lang=js&"
export * from "./ginpass.vue?vue&type=script&lang=js&"
import style0 from "./ginpass.vue?vue&type=style&index=0&id=7f5e251c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5e251c",
  null
  
)

export default component.exports